module.exports = __webpack_public_path__ + "static/media/README.45e87d83.md";